import React, {useState, useEffect} from "react";
import {ProfileService} from "../services/UserServices";
import {InitialLoader} from "../components/loaders/Loader";
import {HistoryCourses} from "../services/GeneralServices";
import {useHistory, useLocation} from "react-router-dom";

export const GlobalContext = React.createContext({});

function GlobalProvider({children}) {
   const [isLoading, setLoading] = useState(true);
   const [myCoursesList, setMyCourses] = useState({isLoading: true});
   const [menuIsOpen, setMenu] = useState(false);
   const [isAdult, setIsAdult] = useState(false);
   const [token, setToken] = useState(false);
   const [sessionStarted, setSession] = useState(false);
   const [userData, setUserData] = useState({});
   // router
   let history = useHistory();
   let location = useLocation();

   useEffect(() => {
      initialLoginStatus();
   }, []);

   useEffect(() => {
      showNewsletter();
   }, [isLoading, isAdult, userData]);

   useEffect(() => {
      let current = localStorage.getItem("isAdult") ? true : false;
      /* if (window.location.hostname === "localhost") {
         current = true;
      } */
      setIsAdult(current);
   }, [isAdult]);

   useEffect(() => {
      getUserData();
   }, [token]);

   const updateStatus = (val) => {
      /* if (window.location.hostname === "localhost") {
         sessionStorage.setItem("isAdult", "true");
      } else {
         localStorage.setItem("isAdult", "true");
      } */
      localStorage.setItem("isAdult", "true");
      setIsAdult(val);
   };

   function showNewsletter() {
      if (isAdult && !isLoading && !!userData) {
         if (!userData.newsletterSuscription) {
            setTimeout(() => {
               openNEws();
            }, 3500);
         }
      }

      const openNEws = () => {
         history.push({
            search: "?newsLetter=true",
         });
      };
   }

   function initialLoginStatus() {
      // comprobar si hay un token guardado
      let tokenSaved = localStorage.getItem("domecq_token");
      if (tokenSaved) {
         return setToken(tokenSaved);
      }
      setLoading(false);
   }

   function getUserData() {
      // buscar datos de usuario
      if (!token) return false;
      ProfileService({token})
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            // console.log(data[0]);
            setUserData({...data[0]});
            // setUserData({...data[0], newsletterSuscription: 1});
         })
         .then(() => {
            // establecer sesión
            setSession(true);
         })
         .then(() => {
            setLoading(false);
         })
         .catch((e) => {
            setLoading(false);
            console.log(e);
            doLogout();
         });
   }

   function doLogout() {
      setUserData({});
      setSession(false);
      localStorage.removeItem("domecq_token");
   }

   function getMyCourses(force = false) {
      if (myCoursesList.length > 1 && !force) return false;
      HistoryCourses(userData.idUser)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            console.log(data);
            setMyCourses({offer: [...data], isLoading: false});
         })
         .catch((e) => {
            console.log(e);
            setMyCourses({offer: [], isLoading: false});
         });
   }

   // login con facebook

   return (
      <>
         <InitialLoader isVisible={isLoading} />
         <GlobalContext.Provider
            value={{
               // menu
               menuIsOpen: menuIsOpen,
               setMenu: setMenu,
               // mayor de edad
               isAdult: isAdult,
               setIsAdult: updateStatus,
               // sesión iniciada
               sessionStarted: sessionStarted,
               userData: userData,
               doLogout: doLogout,
               //toke
               setToken: setToken,
               token: token,
               //
               getMyCourses: getMyCourses, // obtener lista de curso
               myCoursesList: myCoursesList, // obtener lista de curso
               // login fb
               // fbLogin,
            }}
         >
            {children}
         </GlobalContext.Provider>
      </>
   );
}

export default GlobalProvider;
